import styled from 'styled-components';
import { colors } from 'globalStyles';
import { NavLink } from 'react-router-dom';

export const Wrapper = styled.div`
  color: ${colors.BODY};
  font-weight: 400;
  width: 300px;
`

export const Center = styled.p`
  text-align: center;
`

export const Link = styled(NavLink)`
  color: ${colors.MAIN_COLOR};
  text-align: center;
  text-decoration: underline;

  &:visited {
    color: ${colors.MAIN_COLOR};
  }
`;

export const IconWrapper = styled.div`
  margin: 0 0 2em 0;
  text-align: center;
`;

export const Text = styled.div`
  font-size: 14px;
  line-height: 24px;
  margin: 0 0 2em 0;
`;

export const Ul = styled.ul`
  padding-left: 5px;
  margin: 0;
  font-size: 14px;
  line-height: 19px;
  list-style: none;
`;

export const Li = styled.li`
  &:before {
    line-height: 0px;
    content: '\\2022';
    font-size: 20px;
    padding: 0 12px 0 0;
    color: #C9D7DF;
    display: inline-block;
    vertical-align: middle;
  }
`;



// WEBPACK FOOTER //
// ./src/components/PasswordRequirementsModal/styledComponents.js